import { registerFormFr, registerFormIt } from './registerForm.js';

/** @typedef {{ fr: Record<string, unknown>, it: Record<string, unknown> }} TranslationsRoot */

export const translations = {
  fr: {
    nav: {
      home: 'Accueil',
      tickets: 'Billets',
      partners: 'Partenaires',
      faq: 'FAQ',
      contact: 'Contact',
      payment: 'Paiement',
      juventusCard: 'Juventus Card',
      admin: 'Admin',
      logout: 'Déconnexion',
      login: 'Login',
      register: 'Devenir membre',
    },
    footer: {
      partnersTitle: 'Nos partenaires',
      partnersSubtitle: 'Découvrez nos partenaires officiels',
      becomePartner: 'Devenir partenaires du club',
      contactTitle: 'Contact',
      contactEmailPrefix: 'Email :',
      social: 'Suivez-nous sur les réseaux sociaux',
      clubTitle: 'JOFC Oltre Frontiera',
      clubSubtitle: 'Club Officiel de supporters de la Juventus',
      termsLink: 'Conditions générales de ventes des billets',
      bottom:
        '© {year} Juventus Club Oltre Frontiera. Tous droits réservés. | marchi JUVENTUS, JUVE, JUVENTUS E SCUDETTO, sono di proprietà esclusiva della JUVENTUS FC S.P.A. - www.juventus.com',
    },
    seo: {
      tickets: {
        title: 'Billets — My Ticket Shop',
        description:
          'Commandez vos billets pour les matchs de la Juventus. Membres actifs du JOFC Oltre Frontiera : consultez les matchs à venir et accédez au My Ticket Shop.',
      },
      faq: {
        title: 'FAQ',
        description:
          'Réponses aux questions fréquentes sur l’adhésion, les billets, la Juventus Card, le stade et le club de supporters JOFC Oltre Frontiera.',
      },
      partners: {
        title: 'Partenaires',
        description:
          'Découvrez les partenaires officiels du JOFC Oltre Frontiera et les avantages réservés aux membres du club de supporters de la Juventus.',
      },
      contact: {
        title: 'Contact',
        description:
          'Contactez le JOFC Oltre Frontiera par email, téléphone ou formulaire en ligne. Club officiel de supporters de la Juventus, Montreux (Suisse).',
      },
      paiement: {
        title: 'Paiement et comptes bancaires',
        description:
          'Coordonnées bancaires, tarifs des cotisations saison 2026-2027 et modes de paiement pour rejoindre le JOFC Oltre Frontiera.',
      },
      juventusCard: {
        title: 'Juventus Card',
        description:
          'Demandez votre Juventus Card via le JOFC Oltre Frontiera. Carte indispensable pour les billets, abonnements et accès au stade Allianz.',
      },
      ticketPayment: {
        title: 'Achat de billet — My Ticket Shop',
        description:
          'Commandez un billet pour un match de la Juventus : sélection de zone, titulaires et accompagnants.',
      },
    },
    home: {
      languageLabel: 'Langue du site',
      rssTitle: 'Dernières news Tuttosport.com',
      rssLoading: 'Chargement des news Tuttosport...',
      readArticle: 'Lire l’article',
      loading: 'Chargement...',
      prev: 'Précédent',
      next: 'Suivant',
      pageOf: 'Page {page} sur {total}',
      upcomingTitle: 'Matchs à venir',
      buyTicket: 'Commander un billet',
      noMatch: 'Aucun match à venir pour le moment.',
      standingsTitle: 'Classement Serie A',
      standingsLoading: 'Chargement du classement...',
      standingsThRank: '#',
      standingsThTeam: 'Équipe',
      standingsThJ: 'J',
      standingsThG: 'G',
      standingsThN: 'N',
      standingsThP: 'P',
      standingsThGF: 'BP',
      standingsThGA: 'BC',
      standingsThGD: '+/-',
      standingsThPts: 'Pts',
      standingsThForm: 'Forme',
      standingsLegend:
        'J: joués · G: gagnés · N: nuls · P: perdus · BP: buts pour · BC: buts contre · +/-: différence',
      standingsEmpty: 'Aucun classement disponible.',
      membershipTitle: 'Devenez membre du JOFC Oltre Frontiera',
      membershipSubtitle: 'Rejoignez notre communauté de passionnés de la Juventus',
      membershipCta: 'S’inscrire',
      helpTitle: 'Info utiles',
      helpTicketShopTitle: 'MY TICKET SHOP',
      helpTicketShopP1:
        'Sur my ticket shop, vous pouvez retrouver vos billets, segnaposto ou les informations de votre abonnement si vous êtes abonnés au stade. Pour vous enregistrer merci de',
      helpTicketShopClick: 'cliquer ici',
      helpTicketShopP2:
        'Veuillez de préférence vous enregistrer avec votre juventus card ou à défaut avec votre adresse e-mail (la même utilisée pour votre inscription au club) si pas en possession de la juventus card.',
      helpTicketShopP3: 'Pour accéder à votre my ticket shop, merci de ',
      helpTicketShopP4:
        'En outre pour les abonnés au stade, vous pouvez voir votre crédit suite à la revente de votre place à la Juventus, effectuer un changement de nom, remise en vente de votre abonnement à la Juventus ou à Cedi à JOFC.',
      helpFanTitle: 'FAN SERVICE JUVENTUS',
      helpFanP:
        'Pour toute information ou demande d’assistance, le FAN SERVICE JUVENTUS est à votre disposition (billets pas reçu, erreur sur le billet, etc.).',
    },
    tickets: {
      pageTitle: 'My Ticket Shop',
      loading: 'Chargement des billets...',
      noTickets: 'Aucun billet disponible pour le moment.',
      infoPrice: 'Info et prix',
      buy: 'Commander',
      full: 'Complet',
      salesPhases: 'Phases de vente',
      noPhases: 'Aucune phase définie.',
      helpTitle: 'Info utiles',
      helpTicketShopTitle: 'MY TICKET SHOP',
      helpTicketShopP1:
        'Sur my ticket shop, vous pouvez retrouver vos billets, segnaposto ou les informations de votre abonnement si vous êtes abonnés au stade. Pour vous enregistrer merci de',
      helpTicketShopClick: 'cliquer ici',
      helpTicketShopP2:
        'Veuillez de préférence vous enregistrer avec votre juventus card ou à défaut avec votre adresse e-mail (la même utilisée pour votre inscription au club) si pas en possession de la juventus card.',
      helpTicketShopP3: 'Pour accéder à votre my ticket shop, merci de ',
      helpTicketShopP4:
        'En outre pour les abonnés au stade, vous pouvez voir votre crédit suite à la revente de votre place à la Juventus, effectuer un changement de nom, remise en vente de votre abonnement à la Juventus ou à Cedi à JOFC.',
      helpFanTitle: 'FAN SERVICE JUVENTUS',
      helpFanP:
        'Pour toute information ou demande d’assistance, le FAN SERVICE JUVENTUS est à votre disposition (billets pas reçu, erreur sur le billet, etc.).',
      alreadyOrdered: 'Demande déjà envoyée',
    },
    ticketPayment: {
      loading: 'Chargement...',
      backToTickets: '← Retour aux billets',
      pageTitle: 'Achat de billet',
      alreadySentTitle: 'Demande déjà envoyée',
      alreadySentHeading: 'Une demande de billet a déjà été envoyée pour ce match',
      alreadySentBody:
        'Vous avez déjà soumis une commande pour {matchTitle}. Il n\'est pas possible de commander plusieurs fois le même billet.',
      orderDateLabel: 'Date de la demande :',
      statusLabel: 'Statut :',
      quantityLabel: 'Quantité :',
      ticketsUnit: 'billet(s)',
      alreadySentNote:
        'Si vous souhaitez modifier votre demande, contactez l\'administration du club.',
      backToList: 'Retour à la liste des billets',
      stadium: 'Stade:',
      date: 'Date:',
      attendeesTitle: 'Titulaires des billets',
      subscriberNotice:
        'Votre abonnement couvre votre place pour ce match. Renseignez ci-dessous les informations de l\'accompagnant.',
      ecardCode: 'e-card *',
      ecardCodeSummary: 'e-card:',
      placeholderEcardCode: 'JOFC-XXXXXXXX',
      ecardCodeHelp: 'Code e-card JOFC attribué pour la saison en cours.',
      companionEcardHelp: 'Saisissez l\'e-card du membre accompagnant, puis quittez le champ pour charger ses informations.',
      companionEcardLooking: 'Recherche du membre...',
      companionPrefilledNote: 'Informations du membre chargées automatiquement à partir de l\'e-card.',
      alertCompanionEcardNotFound: 'Aucun membre actif trouvé pour cette e-card.',
      alertCompanionEcardOwn: 'Vous ne pouvez pas utiliser votre propre e-card pour un accompagnant.',
      alertCompanionEcardDuplicate: 'Cette e-card est déjà utilisée pour un autre billet de cette commande.',
      alertCompanionEcardVerify:
        'Veuillez saisir une e-card valide pour le billet {number} (accompagnant) afin de charger les informations du membre.',
      pnrCode: 'Code PNR *',
      pnrCodeSummary: 'Code PNR:',
      placeholderPnrCode: 'Code PNR de votre abonnement',
      pnrCodeHelp:
        'Code PNR disponible dans votre my ticket shop Juventus (abonnés au stade).',
      ticketPrimaryLabel: 'Billet 1 — Titulaire (vous)',
      prefilledNote: 'Pré-rempli automatiquement à partir de votre compte.',
      lastName: 'Nom *',
      firstName: 'Prénom *',
      juventusCard: 'Juventus Card',
      dateOfBirth: 'Date de naissance *',
      countryResidence: 'Pays de résidence *',
      cityResidence: 'Ville de résidence *',
      email: 'Email *',
      mobile: 'N° de mobile *',
      companionToggle:
        'Commander un billet pour un accompagnant (Billet 2 — uniquement membre actif du JOFC Oltre Frontiera)',
      addCompanion:
        '(uniquement membre actif du JOFC Oltre Frontiera) + Ajouter un autre accompagnant',
      ticketCompanionLabel:
        'Billet {number} — Accompagnant (uniquement membre actif du JOFC Oltre Frontiera)',
      remove: 'Retirer',
      companionDisabledNote:
        'Cochez « Commander un billet pour un accompagnant » pour renseigner ce formulaire.',
      placeholderLastName: 'Nom',
      placeholderFirstName: 'Prénom',
      placeholderJuventusCard: 'N° carte si en possession',
      placeholderCountry: 'Pays',
      placeholderCity: 'Ville',
      placeholderEmail: 'email@exemple.com',
      placeholderPhone: '+41...',
      zoneSelectionTitle: 'Sélection de la zone',
      stadiumMapAlt: 'Plan du stade Juventus',
      selectedSector: 'Secteur sélectionné:',
      zone: 'Zone:',
      price: 'Prix:',
      minorPrice: 'Prix mineur:',
      summaryAdultLine: 'Plein tarif ({count} × {price} €)',
      summaryMinorLine: 'Tarif mineur ({count} × {price} €)',
      summaryMinorRebate: 'Économie tarif mineur:',
      sectorInstruction:
        'Cliquez sur un numéro de secteur dans le plan du stade pour le sélectionner',
      awayPriceTitle: 'Prix du billet',
      awayPriceNote: 'Match à l\'extérieur - Prix unique pour tous les billets',
      unitPrice: 'Prix unitaire',
      priceNotDefined: 'Prix non défini pour ce match',
      companionInfoTitle: 'Billet accompagnant',
      companionInfoBody:
        'Le formulaire accompagnant (nom, prénom, Juventus Card, date de naissance, pays, ville, email, mobile) est affiché en haut de page. Cochez la case pour commander un billet accompagnant en plus du vôtre.',
      summaryTitle: 'Résumé de votre demande',
      match: 'Match:',
      zoneNotSelected: 'Non sélectionnée',
      sector: 'Secteur:',
      unitPriceLabel: 'Prix unitaire:',
      ticketCount: 'Nombre de billets:',
      ticketSingular: 'billet',
      ticketPlural: 'billets',
      quantityYouPlusCompanion: '(vous + {count} accompagnant{companionPlural})',
      quantityCompanionOnly: '({count} accompagnant{companionPlural})',
      companionSingular: '',
      companionPlural: 's',
      total: 'Total:',
      paymentSectionTitle: 'Mode de paiement',
      paymentSectionIntro:
        'Indiquez comment vous comptez régler le(s) billet(s) une fois la commande confirmée. Coordonnées bancaires sur la page',
      paymentSectionLink: 'Paiement et comptes bancaires',
      paymentMethodLabel: 'Mode de paiement *',
      selectPayment: 'Sélectionner',
      optgroupEbanking: 'E-banking',
      optEbanking: 'E-banking (virement bancaire)',
      optgroupTwint: 'Twint',
      optTwint: 'Twint',
      optgroupRevolut: 'Revolut',
      optRevolut: 'Carte Revolut',
      optgroupCredit: 'Carte de crédit',
      optCredit: 'Carte de crédit',
      paymentCurrencyLabel: 'Devise *',
      currencyChf: 'CHF (francs suisses)',
      currencyEur: 'EUR (euros)',
      alertPaymentMethod: 'Veuillez sélectionner un mode de paiement.',
      alertPaymentCurrency: 'Veuillez sélectionner une devise.',
      requestInfo:
        'En cliquant sur le bouton ci-dessous, vous envoyez une demande de billet. Vous recevrez un email de confirmation et l\'administrateur sera notifié de votre demande.',
      cancel: 'Annuler',
      submit: 'Envoyer demande de billet',
      submitting: 'Envoi en cours...',
      statusConfirmed: 'Confirmée',
      statusCancelled: 'Annulée',
      statusPending: 'En attente',
      alertLogin: 'Veuillez vous connecter pour demander un billet',
      alertMissingTicket: 'Erreur: Informations du billet manquantes',
      alertSelectZone: 'Veuillez sélectionner une zone pour votre billet',
      alertCompanionFields:
        'Veuillez remplir tous les champs obligatoires pour le billet {number} (accompagnant).',
      alertMinOneTicket: 'Veuillez commander au moins un billet.',
      alertMinOneCompanion: 'Veuillez commander au moins un billet accompagnant.',
      alertSuccess:
        'Votre demande de billet a été envoyée avec succès! Vous recevrez un email de confirmation.',
      alertError: 'Erreur lors de l\'envoi de la demande. Veuillez réessayer.',
      alertIdentityExpired:
        "Votre pièce d'identité a expiré. Merci d'envoyer la nouvelle pièce d'identité à info@oltrefrontiera.ch",
      alertEcardRequired: 'Veuillez renseigner votre code e-card.',
      alertPnrRequired: 'Veuillez renseigner votre code PNR (abonnés au stade).',
    },
    ticketTravel: {
      title: 'Informations de voyage',
      intro:
        'Merci de renseigner le trajet aller et retour pour chaque personne titulaire d\'un billet dans cette commande.',
      introMulti:
        'Renseignez d\'abord le voyage de la première personne. Les autres personnes reprennent automatiquement les mêmes informations (aller et retour) ; vous pouvez les modifier individuellement avant l\'envoi.',
      beforeOrderIntro:
        'Ce match nécessite des informations de voyage pour chaque titulaire. Remplissez ce formulaire avant d\'envoyer votre demande de billet.',
      afterOrderIntro:
        'Votre demande de billet a été envoyée avec succès. Vous pouvez maintenant compléter les informations de voyage ci-dessous.',
      warningFr:
        'Les billets ne sont pas garantis. En cas d\'attribution de toutes les places par Turin, les billets sont considérés comme confirmés et ne peuvent plus être annulés. Nous vous conseillons de ne réserver ni transport ni hôtel avant la confirmation du billet.',
      warningIt:
        'I biglietti non sono garantiti. In caso di assegnazione di tutti i posti da parte di Torino, i biglietti saranno considerati confermati e non potranno più essere annullati. Si consiglia di non prenotare mezzi di trasporto né hotel prima della conferma del biglietto.',
      copyFrom: 'Recopier les informations de voyage de',
      copyApply: 'Vers les autres personnes',
      personFallback: 'Personne {number}',
      personTitle: '{name}',
      outboundTitle: 'Voyage aller',
      returnTitle: 'Voyage retour',
      departureCountry: 'Pays de départ *',
      departureCity: 'Ville de départ *',
      date: 'Date *',
      arrivalTime: 'Heure d\'arrivée *',
      transportMode: 'Mode de transport *',
      selectTransport: 'Sélectionner',
      transport: {
        car: 'Voiture',
        train: 'Train',
        plane: 'Avion',
        bus: 'Bus',
      },
      licensePlate: 'Numéro de plaque d\'immatriculation *',
      trainNumber: 'Numéro complet du train *',
      trainStation: 'Nom de la gare *',
      trainStationCity: 'Ville de la gare *',
      flightNumber: 'Numéro complet du vol *',
      airport: 'Nom de l\'aéroport *',
      busDeparture: 'Lieu de départ *',
      waiverTitle: 'Décharge',
      waiverText:
        'Toute réservation de vol, de train, de voiture ou de bus, ainsi que toute réservation d\'hôtel, est à ma charge et sous ma responsabilité. Si ma demande de billet est refusée alors que j\'ai déjà réservé un transport ou un hôtel, je ne pourrai demander au JOFC Oltre Frontiera le remboursement total ou partiel de ces frais.',
      accept: 'J\'accepte',
      refuse: 'Je refuse',
      submit: 'Enregistrer les informations de voyage',
      submitting: 'Enregistrement...',
      submitSuccess: 'Informations de voyage enregistrées.',
      submitError: 'Impossible d\'enregistrer les informations de voyage.',
      alreadySentTravelNote:
        'Vous pouvez compléter ou mettre à jour les informations de voyage pour cette commande.',
      validation: {
        waiver: 'Vous devez accepter la décharge pour envoyer le formulaire.',
        departureCountry: '{leg} : pays de départ requis.',
        departureCity: '{leg} : ville de départ requise.',
        date: '{leg} : date requise.',
        arrivalTime: '{leg} : heure d\'arrivée requise.',
        transportMode: '{leg} : mode de transport requis.',
        licensePlate: '{leg} : numéro de plaque requis.',
        trainNumber: '{leg} : numéro de train invalide (lettres et chiffres).',
        trainStation: '{leg} : nom de la gare requis.',
        trainStationCity: '{leg} : ville de la gare requise.',
        flightNumber: '{leg} : numéro de vol invalide (lettres et chiffres).',
        airport: '{leg} : nom de l\'aéroport requis.',
        busDeparture: '{leg} : lieu de départ requis.',
      },
    },
    faq: {
      title: 'Foire Aux Questions',
      q1: 'Comment devenir membre du JOFC Oltre Frontiera?',
      a1:
        '<p>Pour devenir membre, il suffit de cliquer sur le bouton «&nbsp;Devenir membre&nbsp;» dans le menu et de remplir le formulaire d\'inscription. Une fois votre compte créé, vous aurez accès à tous les avantages membres.</p>',
      q2: 'Comment commander des billets?',
      a2:
        '<p>Les membres peuvent commander des billets directement depuis la section «&nbsp;Billets&nbsp;» après s\'être connectés à leur compte. Les billets disponibles sont régulièrement mis à jour.</p>',
      q3: 'QUELLES SONT LES CONDITIONS DE VENTE DES BILLETS DE MATCH?',
      a3:
        '<p>Ci-dessous, le paragraphe 6 des conditions de vente des billets de match. Vous pouvez lire le règlement complet (en italien) en cliquant sur : <a href="/terms">Conditions générales de ventes des billets</a></p><p><strong>Paragraphe 6</strong></p><p class="faq-answer-it" lang="it">Come previsto dal regolamento della Lega Nazionale Professionisti Serie A – F.I.G.C., in caso di sospensione delle gare dopo l’inizio del secondo tempo, il titolo di accesso non sarà valido per la gara di recupero. L’obbligo di giocare partite a porte chiuse, e/o eventuali chiusure di settori, e/o l’eventuale squalifica del campo e la disputa di partite in campo neutro, disposti per Legge o provvedimento di autorità pubbliche o sportive, non genereranno diritto al rimborso e le spese di trasferta saranno a carico del titolare del titolo di accesso. La predetta limitazione non opera nei casi di inadempimento colpevole ex art. 1218 c.c. della Juventus, restando inteso che non può essere considerato inadempimento colpevole di Juventus l’impossibilità di assistere alla partita per cause di forza maggiore, caso fortuito o per disposizioni degli organismi o delle Autorità competenti in seguito a fatti e/o eventi non dipendenti da responsabilità diretta di Juventus.</p>',
      q4: "Quels sont les avantages d'être membre?",
      a4:
        '<p>Les membres ont accès à l\'achat de billets avant la vente libre, à un prix réduit par rapport à la vente sur le site officiel de la Juventus.</p><p>Ils ont également des réductions auprès de nos partenaires et peuvent participer à nos événements exclusifs.</p><p>Vous n\'êtes pas membre du JOFC Oltre Frontiera&nbsp;? <a href="/register">Cliquez sur Devenir membre</a>.</p>',
      q5: 'A quoi sert la Juventus Card ?',
      a5:
        '<p>La Juventus Card sera nécessaire pour&nbsp;:</p><ul><li>Acheter les billets et accéder au stade pour les matchs pour lesquels des restrictions de vente sont imposées&nbsp;;</li><li>Acheter dans les secteurs visiteurs lorsque la Juventus joue en Italie&nbsp;;</li><li>Acheter un abonnement à la saison&nbsp;;</li><li>Recevoir un changement de nom d\'un abonné.</li></ul><p>La Juventus Card est vivement conseillée (idéalement faite via le club).</p><p>Pour commander votre Juventus Card, rendez-vous dans l\'onglet <a href="/juventus-card">Juventus Card</a>.</p>',
      q6: 'QUI PEUT COMMANDER DES BILLETS AU JOFC OLTRE FRONTIERA?',
      a6:
        '<p>Seuls les membres actifs du JOFC Oltre Frontiera peuvent commander des billets.</p><p>Vous n\'êtes pas encore membre et vous souhaitez le devenir&nbsp;? <a href="/register">Cliquez sur Devenir membre</a>.</p>',
      q7: 'QUE FAIRE EN CAS DE PERTE/VOL/DÉTÉRIORATION DE MA JUVENTUS CARD?',
      a7:
        '<p>Consultez la <a href="/juventus-card">page Juventus Card</a> et suivez les instructions.</p>',
      q8: 'PUIS-JE ANNULER OU TRANSMETTRE MON BILLET À UNE AUTRE PERSONNE?',
      a8:
        '<p>Dès que la Juventus a confirmé le billet, il n\'est plus possible de l\'annuler ou de le transmettre à une autre personne.</p>',
      q9: 'QUAND PUIS-JE IMPRIMER LE SEGNAPOSTO?',
      a9:
        '<p>Le Segnaposto est disponible entre 1 et 7 jours avant la date du match.</p><p>Le JOFC Oltre Frontiera envoie sur le groupe WhatsApp un message lorsque les billets sont chargés.</p><p>Depuis la saison 2021-2022, la Juventus envoie directement le segnaposto ou le billet au format PDF au membre par e-mail.</p><p>Si vous ne l\'avez pas reçu, vous pouvez le retrouver sur My Ticket&nbsp;; voir les infos utiles sur la <a href="/">page d\'accueil</a> ou la <a href="/billets">page Billets</a>.</p>',
      q10: "OÙ PARQUER LA VOITURE LORSQU'ON ARRIVE AU STADE?",
      a10:
        '<p>Vous pouvez parquer votre voiture au parking officiel du stade.</p><p>Autour du stade, il existe de nombreux endroits où vous pouvez vous garer.</p><p>Le JOFC Oltre Frontiera conseille de parquer au restaurant <a href="https://www.labohemetorino.com/" target="_blank" rel="noopener noreferrer">La Boheme Hotel &amp; Ristorante</a>, situé en face des entrées du secteur C.</p><p><a href="https://www.labohemetorino.com/" target="_blank" rel="noopener noreferrer">La Boheme Hotel &amp; Ristorante</a> — plus d\'informations.</p><p>Évitez de parquer dans le centre commercial (matchs du soir)&nbsp;: aux alentours du stade, il y a beaucoup de vols.</p>',
      q11: 'Où je trouve mon numéro e-card ?',
      a11:
        '<p>Dans votre profil en cliquant en haut à droite sur votre prénom.</p>',
      q12: 'Où je peux changer de langue ?',
      a12:
        '<p>Dans votre profil en cliquant en haut à droite sur votre prénom.</p>',
    },
    contact: {
      title: 'Contactez-nous',
      infoTitle: 'Informations de contact',
      email: 'Email',
      phone: 'Téléphone',
      address: 'Adresse',
      addressLine: 'Juventus Club Oltre Frontiera<br />CH - 1820 Montreux',
      formTitle: 'Envoyez-nous un message',
      formNote:
        'Nous ne donnerons aucune suite à une demande de billets pour des non membres du JOFC Oltre Frontiera',
      success:
        'Merci pour votre message! Nous vous répondrons dans les plus brefs délais.',
      nameLabel: 'Nom complet',
      namePlaceholder: 'Votre nom',
      emailLabel: 'Email',
      emailPlaceholder: 'votre@email.com',
      subjectLabel: 'Sujet',
      subjectPlaceholder: 'Sujet de votre message',
      messageLabel: 'Message',
      messagePlaceholder: 'Votre message...',
      submit: 'Envoyer le message',
      sending: 'Envoi en cours...',
      errorSend: 'Impossible d\'envoyer le message. Réessayez plus tard ou écrivez-nous à info@oltrefrontiera.ch.',
    },
    partners: {
      title: 'Partners',
    },
    newsDetail: {
      loading: 'Chargement...',
      notFound: 'Article non trouvé',
      backHome: 'Retour à l’accueil',
      back: '← Retour',
      byAuthor: 'Par {name}',
    },
    login: {
      title: 'Connexion',
      email: 'Email',
      password: 'Mot de passe',
      forgot: 'Mot de passe oublié?',
      submit: 'Se connecter',
      submitting: 'Connexion...',
      error: 'Email ou mot de passe incorrect',
      notMember: 'Pas encore membre?',
      register: 'S’inscrire',
      devMode: '🛠️ Mode Développement',
      show: 'Afficher',
      hide: 'Masquer',
      devHint:
        'Connexion rapide pour le développement local (non disponible en production)',
      devLoading: 'Chargement des utilisateurs...',
      devNone: 'Aucun utilisateur trouvé',
    },
    forgotPassword: {
      title: 'Mot de passe oublié',
      intro:
        'Entrez votre adresse email. Si un compte existe, vous recevrez un lien pour réinitialiser votre mot de passe.',
      emailLabel: 'Email',
      submit: 'Envoyer le lien',
      submitting: 'Envoi...',
      sending: 'Envoi en cours...',
      backLogin: 'Retour à la connexion',
      errorGeneric: 'Une erreur est survenue. Veuillez réessayer.',
      successBody:
        'Un email avec les instructions pour réinitialiser votre mot de passe a été envoyé. Vérifiez votre boîte de réception (et vos spams).',
      notFound: 'Aucun compte associé à cet email.',
      notFoundBold: 'Aucun compte associé à cette adresse email.',
      notFoundCreate: 'Souhaitez-vous créer un compte ?',
      registerCta: 'S’inscrire',
    },
    resetPassword: {
      pageTitle: 'Réinitialisation du mot de passe',
      checking: 'Vérification du lien...',
      checkingShort: 'Vérification du lien...',
      invalidTitle: 'Lien invalide ou expiré',
      invalidBody:
        'Ce lien de réinitialisation est invalide ou a expiré. Veuillez demander un nouveau lien.',
      requestNewLink: 'Demander un nouveau lien',
      title: 'Nouveau mot de passe',
      formIntro: 'Choisissez un nouveau mot de passe pour votre compte.',
      password: 'Nouveau mot de passe *',
      confirm: 'Confirmer le mot de passe *',
      submit: 'Réinitialiser le mot de passe',
      submitting: 'Enregistrement...',
      successTitle: 'Mot de passe réinitialisé',
      successBody:
        'Votre mot de passe a été réinitialisé. Vous pouvez maintenant vous connecter.',
      successTitleAlt: 'Mot de passe mis à jour',
      successBodyAlt: 'Vous pouvez maintenant vous connecter avec votre nouveau mot de passe.',
      goLogin: 'Se connecter',
      mismatch: 'Les mots de passe ne correspondent pas.',
      tooShort: 'Le mot de passe doit contenir au moins 6 caractères.',
      errorGeneric: 'Une erreur est survenue. Veuillez réessayer.',
      backLogin: 'Retour à la connexion',
    },
    magicLink: {
      pageTitle: 'Vérification du lien de connexion',
      verifying: 'Vérification en cours...',
      success: 'Connexion réussie ! Redirection en cours...',
      backLoginPage: 'Retour à la page de connexion',
    },
    membership: {
      loading: 'Chargement...',
      inactiveForSeason:
        'Votre statut membre n\'est pas actif pour la saison 2026-2027. Vous ne pouvez pas commander de billets ni demander une Juventus Card. Contactez le club si vous pensez qu\'il s\'agit d\'une erreur.',
    },
    juventusCard: {
      title: 'Juventus Card',
      intro:
        '<p>La Juventus Card est nécessaire pour&nbsp;:</p><ul><li>Acheter des billets et accéder au stade pour les matchs soumis à des restrictions de vente</li><li>Achat de billets pour le secteur réservé aux visiteurs en Italie</li><li>Acheter un abonnement à la saison</li><li>Recevoir un transfert de nom d\'un abonné</li></ul><p>La Juventus Card est vivement conseillée — idéalement obtenue via le club.</p>',
      loginHint:
        'Vous avez déjà envoyé une demande ? Connectez-vous pour voir son statut et accéder au formulaire de déclaration de perte.',
      loading: 'Chargement...',
      statusTitle: 'Statut de votre demande Juventus Card',
      statusLabel: 'Statut :',
      statusPending: 'En cours de traitement',
      statusProcessed: 'Traitée',
      requestDate: 'Demande du',
      lostCta: 'Déclarer une perte de Juventus Card',
      ctaText: 'Pour demander votre Juventus Card, remplissez le formulaire dédié.',
      ctaRequest: 'Demander la Juventus Card',
      inactiveHint: 'Connectez-vous avec un compte membre actif pour la saison 2026-2027.',
    },
    terms: {
      title: 'Règlements et conditions',
      intro:
        'Téléchargez les documents officiels Juventus (Allianz Stadium, Juventus Card, membership, abonnements et billets) au format PDF.',
      download: 'Télécharger le PDF',
    },
    paiement: {
      title: 'Paiement et comptes bancaires',
      chfTitle: 'Compte en francs suisses',
      chfPurpose: 'Compte en francs suisses pour le paiement de la cotisation',
      eurTitle: 'Compte en Euros',
      eurPurpose:
        'Compte en Euros pour le paiement de la cotisation, billets, Juventus Card et abonnement',
      beneficiary: 'Bénéficiaire:',
      address: 'Adresse:',
      iban: 'IBAN:',
      bic: 'BIC:',
      postal: 'Compte postal:',
      pricingTitle: 'Cotisations Saison 2026-2027',
      paymentMode: 'Mode de paiement',
      tierAdult: 'JOFC Adult',
      tierU14: 'Under 14',
      tierU5: 'Under 5',
      tierU5TableFree: 'Gratuit',
      priceChf: 'Prix (CHF)',
      priceEur: 'Prix (€)',
      ebanking: 'E-banking',
      twint: 'Twint au 0786289688',
      revolut: '*Carte Revolut',
      credit: '*Carte de crédit',
      smsNote: 'Envoyer un SMS ou WhatsApp au +41786289688',
      cotisationAdultTitle: 'JOFC Adult — 40 CHF / 40 €',
      cotisationAdultBody:
        'Inclus : Membership Black &amp; White digitale gratuit + un porte-clé',
      cotisationU14Title: 'Under 14 — 30 CHF / 30 €',
      cotisationU14Body:
        '(né(e) après le 01.07.2013)<br /><br />Inclus : Membership Junior + un bonnet',
      cotisationU5Title: 'Under 5 — Gratuit',
      cotisationU5Body: '(né(e) après le 01.07.2022)',
      juveCardTitle: 'Prix Juventus Card (ex-tessera del tifoso) saison 2026-2027',
    },
    account: {
      pageTitle: 'Mon compte',
      loading: 'Chargement...',
      loadError: 'Erreur lors du chargement des données',
      alertLoadError: 'Erreur lors du chargement des données',
      alertSaveOk: 'Profil mis à jour avec succès',
      alertSaveError: 'Erreur lors de la mise à jour',
      alertDeleteOk:
        'Votre demande de suppression de compte a été enregistrée. Un administrateur vous contactera sous peu.',
      alertDeleteError: "Erreur lors de l'envoi de la demande",
      sectionAccount: 'Informations du compte',
      sectionReadonly: 'Informations personnelles (non modifiables)',
      civMonsieur: 'Monsieur',
      civMadame: 'Madame',
      civility: 'Civilité',
      firstName: 'Prénom',
      lastName: 'Nom',
      dateOfBirth: 'Date de naissance',
      sexe: 'Sexe',
      sexeHomme: 'Homme',
      sexeFemme: 'Femme',
      membershipType: "Type d'adhésion",
      ecardCode: 'e-card',
      pnrCode: 'Code PNR',
      sectionEditable: 'Informations modifiables',
      emailPrimary: 'Email principal *',
      emailSecondary: 'Email secondaire',
      emailOptionalPh: 'Email optionnel',
      phone: 'Téléphone *',
      phonePh: '+41791234567',
      addressTitle: 'Adresse',
      street: 'Rue *',
      streetNumber: 'Numéro *',
      city: 'Ville *',
      canton: 'Canton',
      cantonPh: 'VD, VS, GE, etc.',
      postalCode: 'Code postal *',
      country: 'Pays *',
      save: 'Enregistrer les modifications',
      saving: 'Enregistrement...',
      sectionConsents: 'Consentements et communications',
      consentsIntro: 'Vous pouvez modifier vos préférences de consentement à tout moment.',
      consentNewsletter: 'Je souhaite recevoir la newsletter et les informations sur les événements du club',
      sectionPrefs: 'Préférences du compte',
      prefLang: 'Langue préférée',
      prefLangHelp: 'Utilisée pour les e-mails du club et l’affichage du site.',
      saveLanguage: 'Enregistrer la langue',
      savingLanguage: 'Enregistrement...',
      alertLanguageOk: 'Langue préférée mise à jour',
      alertLanguageError: 'Erreur lors de la mise à jour de la langue',
      langFr: 'Français',
      langIt: 'Italien',
      memberSince: 'Membre depuis :',
      statusLabel: 'Statut :',
      statusActive: 'Membre actif',
      sectionOrders: 'Historique des commandes',
      loadingOrders: 'Chargement des commandes...',
      noOrders: 'Aucune commande de billet pour le moment.',
      orderMatchFallback: 'Match',
      orderStadium: 'Stade :',
      orderDate: 'Date :',
      orderQty: 'Quantité :',
      orderTickets: '{n} billet(s)',
      orderPlaced: 'Date de commande :',
      orderNotes: 'Notes :',
      orderStatusPending: 'En attente',
      orderStatusConfirmed: 'Confirmé',
      orderStatusCancelled: 'Annulé',
      na: 'N/A',
      membershipUndefined: 'Non défini',
      membershipPlusU14: 'PLUS U14',
      membershipPlus: 'PLUS',
      membershipStar: 'Star',
      membershipBase: 'Base',
      membershipStandard: 'Standard',
      membershipAbonne: 'Abonné',
      membershipNonAbonne: 'Non abonné',
      membershipUnder5: 'Under 5',
      membershipJofcAdult: 'JOFC Adult',
      membershipJofcUnder14: 'JOFC under 14',
      membershipJofcUnder5: 'JOFC Under 5',
      membershipJofcFull: 'JOFC Abonné Full',
      membershipNewsletter: 'Newsletter',
      sectionDanger: 'Suppression du compte',
      dangerP1:
        'Si vous souhaitez supprimer votre compte et toutes vos données, vous pouvez faire une demande ci-dessous.',
      dangerWarn: 'Attention :',
      dangerP2: 'Cette action est irréversible. Un administrateur vous contactera pour confirmer la suppression.',
      dangerCta: 'Demander la suppression de mon compte',
      modalTitle: 'Confirmer la demande de suppression',
      modalP1: 'Êtes-vous sûr de vouloir demander la suppression de votre compte ?',
      modalP2:
        "Cette action enverra une demande à l'administrateur. Vous serez contacté pour confirmer la suppression définitive.",
      modalConfirm: 'Confirmer la demande',
      modalCancel: 'Annuler',
    },
    newsCard: {
      readArticle: 'Lire l’article',
    },
    registerForm: registerFormFr,
  },
  it: {
    nav: {
      home: 'Home',
      tickets: 'Biglietti',
      partners: 'Partner',
      faq: 'FAQ',
      contact: 'Contatti',
      payment: 'Pagamento',
      juventusCard: 'Juventus Card',
      admin: 'Admin',
      logout: 'Disconnetti',
      login: 'Accedi',
      register: 'Diventa socio',
    },
    footer: {
      partnersTitle: 'I nostri partner',
      partnersSubtitle: 'Scopri i nostri partner ufficiali',
      becomePartner: 'Diventa partner del club',
      contactTitle: 'Contatti',
      contactEmailPrefix: 'Email:',
      social: 'Seguici sui social',
      clubTitle: 'JOFC Oltre Frontiera',
      clubSubtitle: 'Club ufficiale di tifosi della Juventus',
      termsLink: 'Condizioni generali di vendita dei biglietti',
      bottom:
        '© {year} Juventus Club Oltre Frontiera. Tutti i diritti riservati. | marchi JUVENTUS, JUVE, JUVENTUS E SCUDETTO, sono di proprietà esclusiva della JUVENTUS FC S.P.A. - www.juventus.com',
    },
    seo: {
      tickets: {
        title: 'Biglietti — My Ticket Shop',
        description:
          'Ordina i biglietti per le partite della Juventus. Soci attivi del JOFC Oltre Frontiera: consulta le prossime partite e accedi al My Ticket Shop.',
      },
      faq: {
        title: 'FAQ',
        description:
          'Risposte alle domande frequenti su iscrizione, biglietti, Juventus Card, stadio e club ufficiale di tifosi JOFC Oltre Frontiera.',
      },
      partners: {
        title: 'Partner',
        description:
          'Scopri i partner ufficiali del JOFC Oltre Frontiera e i vantaggi riservati ai soci del club di tifosi della Juventus.',
      },
      contact: {
        title: 'Contatti',
        description:
          'Contatta il JOFC Oltre Frontiera via email, telefono o modulo online. Club ufficiale di tifosi della Juventus, Montreux (Svizzera).',
      },
      paiement: {
        title: 'Pagamento e conti bancari',
        description:
          'Coordinate bancarie, tariffe delle quote stagione 2026-2027 e modalità di pagamento per iscriversi al JOFC Oltre Frontiera.',
      },
      juventusCard: {
        title: 'Juventus Card',
        description:
          'Richiedi la tua Juventus Card tramite il JOFC Oltre Frontiera. Tessera indispensabile per biglietti, abbonamenti e accesso all’Allianz Stadium.',
      },
      ticketPayment: {
        title: 'Acquisto biglietto — My Ticket Shop',
        description:
          'Ordina un biglietto per una partita della Juventus: selezione zona, titolari e accompagnatori.',
      },
    },
    home: {
      languageLabel: 'Lingua del sito',
      rssTitle: 'Ultime news Tuttosport.com',
      rssLoading: 'Caricamento news Tuttosport...',
      readArticle: 'Leggi l’articolo',
      loading: 'Caricamento...',
      prev: 'Precedente',
      next: 'Successivo',
      pageOf: 'Pagina {page} di {total}',
      upcomingTitle: 'Prossime partite',
      buyTicket: 'Ordina un biglietto',
      noMatch: 'Nessuna partita in programma al momento.',
      standingsTitle: 'Classifica Serie A',
      standingsLoading: 'Caricamento classifica...',
      standingsThRank: '#',
      standingsThTeam: 'Squadra',
      standingsThJ: 'G',
      standingsThG: 'V',
      standingsThN: 'P',
      standingsThP: 'S',
      standingsThGF: 'GF',
      standingsThGA: 'GS',
      standingsThGD: '+/-',
      standingsThPts: 'Pt',
      standingsThForm: 'Forma',
      standingsLegend:
        'G: giocate · V: vittorie · P: pareggi · S: sconfitte · GF: gol fatti · GS: gol subiti · +/-: differenza reti',
      standingsEmpty: 'Classifica non disponibile.',
      membershipTitle: 'Diventa socio del JOFC Oltre Frontiera',
      membershipSubtitle: 'Unisciti alla nostra community dei tifosi della Juventus',
      membershipCta: 'Iscriviti',
      helpTitle: 'Informazioni utili',
      helpTicketShopTitle: 'MY TICKET SHOP',
      helpTicketShopP1:
        'Su my ticket shop puoi trovare i tuoi biglietti, i segnaposto o le informazioni relative al tuo abbonamento se sei abbonato allo stadio. Per registrarti',
      helpTicketShopClick: 'clicca qui',
      helpTicketShopP2:
        'Preferibilmente registrati con la Juventus Card o, in alternativa, con l’indirizzo email (lo stesso usato per l’iscrizione al club) se non possiedi la Juventus Card.',
      helpTicketShopP3: 'Per accedere al tuo my ticket shop, ',
      helpTicketShopP4:
        'Inoltre, per gli abbonati allo stadio, puoi vedere il tuo credito dopo la rivendita del posto alla Juventus, effettuare un cambio nome, la rimessa in vendita dell’abbonamento alla Juventus o a Cedi al JOFC.',
      helpFanTitle: 'FAN SERVICE JUVENTUS',
      helpFanP:
        'Per qualsiasi informazione o assistenza, il FAN SERVICE JUVENTUS è a tua disposizione (biglietti non ricevuti, errori sul biglietto, ecc.).',
    },
    tickets: {
      pageTitle: 'My Ticket Shop',
      loading: 'Caricamento biglietti...',
      noTickets: 'Nessun biglietto disponibile al momento.',
      infoPrice: 'Info e prezzi',
      buy: 'Ordina',
      full: 'Esaurito',
      salesPhases: 'Fasi di vendita',
      noPhases: 'Nessuna fase definita.',
      helpTitle: 'Informazioni utili',
      helpTicketShopTitle: 'MY TICKET SHOP',
      helpTicketShopP1:
        'Su my ticket shop puoi trovare i tuoi biglietti, i segnaposto o le informazioni relative al tuo abbonamento se sei abbonato allo stadio. Per registrarti',
      helpTicketShopClick: 'clicca qui',
      helpTicketShopP2:
        'Preferibilmente registrati con la Juventus Card o, in alternativa, con l’indirizzo email (lo stesso usato per l’iscrizione al club) se non possiedi la Juventus Card.',
      helpTicketShopP3: 'Per accedere al tuo my ticket shop, ',
      helpTicketShopP4:
        'Inoltre, per gli abbonati allo stadio, puoi vedere il tuo credito dopo la rivendita del posto alla Juventus, effettuare un cambio nome, la rimessa in vendita dell’abbonamento alla Juventus o a Cedi al JOFC.',
      helpFanTitle: 'FAN SERVICE JUVENTUS',
      helpFanP:
        'Per qualsiasi informazione o assistenza, il FAN SERVICE JUVENTUS è a tua disposizione (biglietti non ricevuti, errori sul biglietto, ecc.).',
      alreadyOrdered: 'Richiesta già inviata',
    },
    ticketPayment: {
      loading: 'Caricamento...',
      backToTickets: '← Torna ai biglietti',
      pageTitle: 'Acquisto biglietto',
      alreadySentTitle: 'Richiesta già inviata',
      alreadySentHeading: 'Una richiesta di biglietto è già stata inviata per questa partita',
      alreadySentBody:
        'Hai già inviato un ordine per {matchTitle}. Non è possibile ordinare più volte lo stesso biglietto.',
      orderDateLabel: 'Data della richiesta:',
      statusLabel: 'Stato:',
      quantityLabel: 'Quantità:',
      ticketsUnit: 'biglietto/i',
      alreadySentNote:
        'Se desideri modificare la richiesta, contatta l\'amministrazione del club.',
      backToList: 'Torna all\'elenco dei biglietti',
      stadium: 'Stadio:',
      date: 'Data:',
      attendeesTitle: 'Intestatari dei biglietti',
      subscriberNotice:
        'Il tuo abbonamento copre il tuo posto per questa partita. Inserisci qui sotto i dati dell\'accompagnatore.',
      ecardCode: 'e-card *',
      ecardCodeSummary: 'e-card:',
      placeholderEcardCode: 'JOFC-XXXXXXXX',
      ecardCodeHelp: 'Codice e-card JOFC assegnato per la stagione in corso.',
      companionEcardHelp: 'Inserisci l\'e-card del socio accompagnatore, poi esci dal campo per caricare i suoi dati.',
      companionEcardLooking: 'Ricerca del socio...',
      companionPrefilledNote: 'Dati del socio caricati automaticamente dall\'e-card.',
      alertCompanionEcardNotFound: 'Nessun socio attivo trovato per questa e-card.',
      alertCompanionEcardOwn: 'Non puoi usare la tua e-card per un accompagnatore.',
      alertCompanionEcardDuplicate: 'Questa e-card è già usata per un altro biglietto in questo ordine.',
      alertCompanionEcardVerify:
        'Inserisci una e-card valida per il biglietto {number} (accompagnatore) per caricare i dati del socio.',
      pnrCode: 'Codice PNR *',
      pnrCodeSummary: 'Codice PNR:',
      placeholderPnrCode: 'Codice PNR del tuo abbonamento',
      pnrCodeHelp:
        'Codice PNR disponibile nel tuo my ticket shop Juventus (abbonati allo stadio).',
      ticketPrimaryLabel: 'Biglietto 1 — Titolare (tu)',
      prefilledNote: 'Compilato automaticamente dal tuo account.',
      lastName: 'Cognome *',
      firstName: 'Nome *',
      juventusCard: 'Juventus Card',
      dateOfBirth: 'Data di nascita *',
      countryResidence: 'Paese di residenza *',
      cityResidence: 'Città di residenza *',
      email: 'Email *',
      mobile: 'N° di cellulare *',
      companionToggle:
        'Ordina un biglietto per un accompagnatore (Biglietto 2 — solo socio attivo del JOFC Oltre Frontiera)',
      addCompanion:
        '(solo socio attivo del JOFC Oltre Frontiera) + Aggiungi un altro accompagnatore',
      ticketCompanionLabel:
        'Biglietto {number} — Accompagnatore (solo socio attivo del JOFC Oltre Frontiera)',
      remove: 'Rimuovi',
      companionDisabledNote:
        'Seleziona « Ordina un biglietto per un accompagnatore » per compilare questo modulo.',
      placeholderLastName: 'Cognome',
      placeholderFirstName: 'Nome',
      placeholderJuventusCard: 'N° tessera se in possesso',
      placeholderCountry: 'Paese',
      placeholderCity: 'Città',
      placeholderEmail: 'email@esempio.com',
      placeholderPhone: '+41...',
      zoneSelectionTitle: 'Selezione della zona',
      stadiumMapAlt: 'Pianta dello stadio Juventus',
      selectedSector: 'Settore selezionato:',
      zone: 'Zona:',
      price: 'Prezzo:',
      minorPrice: 'Prezzo minorenne:',
      summaryAdultLine: 'Tariffa intera ({count} × {price} €)',
      summaryMinorLine: 'Tariffa minorenne ({count} × {price} €)',
      summaryMinorRebate: 'Risparmio tariffa minorenne:',
      sectorInstruction:
        'Clicca su un numero di settore nella pianta dello stadio per selezionarlo',
      awayPriceTitle: 'Prezzo del biglietto',
      awayPriceNote: 'Partita in trasferta — prezzo unico per tutti i biglietti',
      unitPrice: 'Prezzo unitario',
      priceNotDefined: 'Prezzo non definito per questa partita',
      companionInfoTitle: 'Biglietto accompagnatore',
      companionInfoBody:
        'Il modulo accompagnatore (cognome, nome, Juventus Card, data di nascita, paese, città, email, cellulare) è mostrato in alto nella pagina. Seleziona la casella per ordinare un biglietto accompagnatore oltre al tuo.',
      summaryTitle: 'Riepilogo della richiesta',
      match: 'Partita:',
      zoneNotSelected: 'Non selezionata',
      sector: 'Settore:',
      unitPriceLabel: 'Prezzo unitario:',
      ticketCount: 'Numero di biglietti:',
      ticketSingular: 'biglietto',
      ticketPlural: 'biglietti',
      quantityYouPlusCompanion: '(tu + {count} accompagnator{companionPlural})',
      quantityCompanionOnly: '({count} accompagnator{companionPlural})',
      companionSingular: 'e',
      companionPlural: 'i',
      total: 'Totale:',
      paymentSectionTitle: 'Modalità di pagamento',
      paymentSectionIntro:
        'Indica come intendi pagare il/i biglietto/i una volta confermato l\'ordine. Coordinate bancarie nella pagina',
      paymentSectionLink: 'Pagamento e conti bancari',
      paymentMethodLabel: 'Modalità di pagamento *',
      selectPayment: 'Seleziona',
      optgroupEbanking: 'E-banking',
      optEbanking: 'E-banking (bonifico bancario)',
      optgroupTwint: 'Twint',
      optTwint: 'Twint',
      optgroupRevolut: 'Revolut',
      optRevolut: 'Carta Revolut',
      optgroupCredit: 'Carta di credito',
      optCredit: 'Carta di credito',
      paymentCurrencyLabel: 'Valuta *',
      currencyChf: 'CHF (franchi svizzeri)',
      currencyEur: 'EUR (euro)',
      alertPaymentMethod: 'Seleziona una modalità di pagamento.',
      alertPaymentCurrency: 'Seleziona una valuta.',
      requestInfo:
        'Cliccando sul pulsante qui sotto, invii una richiesta di biglietto. Riceverai un\'email di conferma e l\'amministratore sarà avvisato della tua richiesta.',
      cancel: 'Annulla',
      submit: 'Invia richiesta biglietto',
      submitting: 'Invio in corso...',
      statusConfirmed: 'Confermata',
      statusCancelled: 'Annullata',
      statusPending: 'In attesa',
      alertLogin: 'Accedi per richiedere un biglietto',
      alertMissingTicket: 'Errore: informazioni biglietto mancanti',
      alertSelectZone: 'Seleziona una zona per il tuo biglietto',
      alertCompanionFields:
        'Compila tutti i campi obbligatori per il biglietto {number} (accompagnatore).',
      alertMinOneTicket: 'Ordina almeno un biglietto.',
      alertMinOneCompanion: 'Ordina almeno un biglietto per un accompagnatore.',
      alertSuccess:
        'La tua richiesta di biglietto è stata inviata con successo! Riceverai un\'email di conferma.',
      alertError: 'Errore durante l\'invio della richiesta. Riprova.',
      alertIdentityExpired:
        "Il tuo documento d'identità è scaduto. Ti preghiamo di inviare il nuovo documento d'identità a info@oltrefrontiera.ch",
      alertEcardRequired: 'Inserisci il codice e-card.',
      alertPnrRequired: 'Inserisci il codice PNR (abbonati allo stadio).',
    },
    ticketTravel: {
      title: 'Informazioni di viaggio',
      intro:
        'Inserisci il viaggio di andata e ritorno per ogni persona titolare di un biglietto in questo ordine.',
      introMulti:
        'Compila prima il viaggio della prima persona. Le altre persone riprendono automaticamente le stesse informazioni (andata e ritorno); puoi modificarle singolarmente prima dell\'invio.',
      beforeOrderIntro:
        'Questa partita richiede informazioni di viaggio per ogni titolare. Compila questo modulo prima di inviare la richiesta di biglietto.',
      afterOrderIntro:
        'La tua richiesta di biglietto è stata inviata con successo. Puoi ora completare le informazioni di viaggio qui sotto.',
      warningFr:
        'Les billets ne sont pas garantis. En cas d\'attribution de toutes les places par Turin, les billets sont considérés comme confirmés et ne peuvent plus être annulés. Nous vous conseillons de ne réserver ni transport ni hôtel avant la confirmation du billet.',
      warningIt:
        'I biglietti non sono garantiti. In caso di assegnazione di tutti i posti da parte di Torino, i biglietti saranno considerati confermati e non potranno più essere annullati. Si consiglia di non prenotare mezzi di trasporto né hotel prima della conferma del biglietto.',
      copyFrom: 'Copia le informazioni di viaggio di',
      copyApply: 'Verso le altre persone',
      personFallback: 'Persona {number}',
      personTitle: '{name}',
      outboundTitle: 'Viaggio di andata',
      returnTitle: 'Viaggio di ritorno',
      departureCountry: 'Paese di partenza *',
      departureCity: 'Città di partenza *',
      date: 'Data *',
      arrivalTime: 'Ora di arrivo *',
      transportMode: 'Mezzo di trasporto *',
      selectTransport: 'Seleziona',
      transport: {
        car: 'Auto',
        train: 'Treno',
        plane: 'Aereo',
        bus: 'Autobus',
      },
      licensePlate: 'Numero di targa *',
      trainNumber: 'Numero completo del treno *',
      trainStation: 'Nome della stazione *',
      trainStationCity: 'Città della stazione *',
      flightNumber: 'Numero completo del volo *',
      airport: 'Nome dell\'aeroporto *',
      busDeparture: 'Luogo di partenza *',
      waiverTitle: 'Liberatoria',
      waiverText:
        'Tutte le prenotazioni di voli, treni, auto o autobus, nonché le prenotazioni di hotel, sono a mio carico e sotto la mia responsabilità. In caso di rifiuto del biglietto, qualora avessi già prenotato un mezzo di trasporto o un hotel, non potrò richiedere al JOFC Oltre Frontiera il rimborso totale o parziale di tali spese.',
      accept: 'Accetto',
      refuse: 'Rifiuto',
      submit: 'Salva le informazioni di viaggio',
      submitting: 'Salvataggio...',
      submitSuccess: 'Informazioni di viaggio salvate.',
      submitError: 'Impossibile salvare le informazioni di viaggio.',
      alreadySentTravelNote:
        'Puoi completare o aggiornare le informazioni di viaggio per questo ordine.',
      validation: {
        waiver: 'Devi accettare la liberatoria per inviare il modulo.',
        departureCountry: '{leg} : paese di partenza obbligatorio.',
        departureCity: '{leg} : città di partenza obbligatoria.',
        date: '{leg} : data obbligatoria.',
        arrivalTime: '{leg} : ora di arrivo obbligatoria.',
        transportMode: '{leg} : mezzo di trasporto obbligatorio.',
        licensePlate: '{leg} : numero di targa obbligatorio.',
        trainNumber: '{leg} : numero treno non valido (lettere e cifre).',
        trainStation: '{leg} : nome stazione obbligatorio.',
        trainStationCity: '{leg} : città della stazione obbligatoria.',
        flightNumber: '{leg} : numero volo non valido (lettere e cifre).',
        airport: '{leg} : nome aeroporto obbligatorio.',
        busDeparture: '{leg} : luogo di partenza obbligatorio.',
      },
    },
    faq: {
      title: 'Domande frequenti',
      q1: 'Come diventare socio del JOFC Oltre Frontiera?',
      a1:
        '<p>Per diventare socio, clicca su «&nbsp;Diventa socio&nbsp;» nel menu e compila il modulo di registrazione. Una volta creato l’account, avrai accesso a tutti i vantaggi riservati ai soci.</p>',
      q2: 'Come ordinare i biglietti?',
      a2:
        '<p>I soci possono ordinare i biglietti dalla sezione «&nbsp;Biglietti&nbsp;» dopo aver effettuato l’accesso. I biglietti disponibili vengono aggiornati regolarmente.</p>',
      q3: 'QUALI SONO LE CONDIZIONI DI VENDITA DEI BIGLIETTI DI PARTITA?',
      a3:
        '<p>Di seguito il paragrafo 6 delle condizioni di vendita dei biglietti di partita. Puoi leggere il regolamento completo (in italiano) cliccando su: <a href="/terms">Condizioni generali di vendita dei biglietti</a></p><p><strong>Paragrafo 6</strong></p><p class="faq-answer-it" lang="it">Come previsto dal regolamento della Lega Nazionale Professionisti Serie A – F.I.G.C., in caso di sospensione delle gare dopo l’inizio del secondo tempo, il titolo di accesso non sarà valido per la gara di recupero. L’obbligo di giocare partite a porte chiuse, e/o eventuali chiusure di settori, e/o l’eventuale squalifica del campo e la disputa di partite in campo neutro, disposti per Legge o provvedimento di autorità pubbliche o sportive, non genereranno diritto al rimborso e le spese di trasferta saranno a carico del titolare del titolo di accesso. La predetta limitazione non opera nei casi di inadempimento colpevole ex art. 1218 c.c. della Juventus, restando inteso che non può essere considerato inadempimento colpevole di Juventus l’impossibilità di assistere alla partita per cause di forza maggiore, caso fortuito o per disposizioni degli organismi o delle Autorità competenti in seguito a fatti e/o eventi non dipendenti da responsabilità diretta di Juventus.</p>',
      q4: 'Quali sono i vantaggi di essere socio?',
      a4:
        '<p>I soci hanno accesso all’acquisto dei biglietti prima della vendita libera, a un prezzo ridotto rispetto al sito ufficiale della Juventus.</p><p>Hanno inoltre sconti presso i nostri partner e possono partecipare ai nostri eventi esclusivi.</p><p>Non sei ancora socio del JOFC Oltre Frontiera? <a href="/register">Clicca su Diventa socio</a>.</p>',
      q5: 'A cosa serve la Juventus Card?',
      a5:
        '<p>La Juventus Card sarà necessaria per:</p><ul><li>Acquistare i biglietti e accedere allo stadio per le partite con restrizioni di vendita;</li><li>Acquistare nei settori ospiti quando la Juventus gioca in Italia;</li><li>Acquistare un abbonamento stagionale;</li><li>Ricevere un cambio nome di un abbonato.</li></ul><p>La Juventus Card è vivamente consigliata (idealmente tramite il club).</p><p>Per ordinare la tua Juventus Card, vai alla scheda <a href="/juventus-card">Juventus Card</a>.</p>',
      q6: 'CHI PUÒ ORDINARE BIGLIETTI AL JOFC OLTRE FRONTIERA?',
      a6:
        '<p>Solo i soci attivi del JOFC Oltre Frontiera possono ordinare biglietti.</p><p>Non sei ancora socio e vuoi diventarlo? <a href="/register">Clicca su Diventa socio</a>.</p>',
      q7: 'COSA FARE IN CASO DI SMARRIMENTO/FURTO/DETERIORAMENTO DELLA MIA JUVENTUS CARD?',
      a7:
        '<p>Vai alla <a href="/juventus-card">pagina Juventus Card</a> e segui le istruzioni.</p>',
      q8: 'POSSO ANNULLARE O TRASFERIRE IL MIO BIGLIETTO A UN’ALTRA PERSONA?',
      a8:
        '<p>Una volta che la Juventus ha confermato il biglietto, non è più possibile annullarlo o trasferirlo a un’altra persona.</p>',
      q9: 'QUANDO POSSO STAMPARE IL SEGNAPOSTO?',
      a9:
        '<p>Il Segnaposto è disponibile tra 1 e 7 giorni prima della data della partita.</p><p>Il JOFC Oltre Frontiera invia sul gruppo WhatsApp un messaggio quando i biglietti sono caricati.</p><p>Dalla stagione 2021-2022, la Juventus invia direttamente il segnaposto o il biglietto in PDF al socio via e-mail.</p><p>Se non l’hai ricevuto, puoi trovarlo su My Ticket; vedi le info utili nella <a href="/">home</a> o nella <a href="/billets">pagina Biglietti</a>.</p>',
      q10: 'DOVE PARCHEGGIARE L’AUTO QUANDO SI ARRIVA ALLO STADIO?',
      a10:
        '<p>Puoi parcheggiare al parcheggio ufficiale dello stadio.</p><p>Intorno allo stadio ci sono molti posti dove parcheggiare.</p><p>Il JOFC Oltre Frontiera consiglia di parcheggiare al ristorante <a href="https://www.labohemetorino.com/" target="_blank" rel="noopener noreferrer">La Boheme Hotel &amp; Ristorante</a>, di fronte agli ingressi del settore C.</p><p><a href="https://www.labohemetorino.com/" target="_blank" rel="noopener noreferrer">La Boheme Hotel &amp; Ristorante</a> — maggiori informazioni.</p><p>Evita di parcheggiare nel centro commerciale (partite serali): nei dintorni dello stadio ci sono molti furti.</p>',
      q11: 'Dove trovo il mio numero e-card ?',
      a11:
        '<p>Nel vostro profilo cliccando sopra a destra sul vostro nome.</p>',
      q12: 'Dove posso cambiare di lingua ?',
      a12:
        '<p>Nel vostro profilo cliccando sopra a destra sul vostro nome.</p>',
    },
    contact: {
      title: 'Contattaci',
      infoTitle: 'Informazioni di contatto',
      email: 'Email',
      phone: 'Telefono',
      address: 'Indirizzo',
      addressLine: 'Juventus Club Oltre Frontiera<br />CH - 1820 Montreux',
      formTitle: 'Inviaci un messaggio',
      formNote:
        'Non daremo seguito a richieste di biglietti da parte di chi non è socio del JOFC Oltre Frontiera',
      success: 'Grazie per il messaggio! Ti risponderemo al più presto.',
      nameLabel: 'Nome e cognome',
      namePlaceholder: 'Il tuo nome',
      emailLabel: 'Email',
      emailPlaceholder: 'tua@email.com',
      subjectLabel: 'Oggetto',
      subjectPlaceholder: 'Oggetto del messaggio',
      messageLabel: 'Messaggio',
      messagePlaceholder: 'Il tuo messaggio...',
      submit: 'Invia il messaggio',
      sending: 'Invio in corso...',
      errorSend:
        'Impossibile inviare il messaggio. Riprova più tardi o scrivi a info@oltrefrontiera.ch.',
    },
    partners: {
      title: 'Partner',
    },
    newsDetail: {
      loading: 'Caricamento...',
      notFound: 'Articolo non trovato',
      backHome: 'Torna alla home',
      back: '← Indietro',
      byAuthor: 'Di {name}',
    },
    login: {
      title: 'Accesso',
      email: 'Email',
      password: 'Password',
      forgot: 'Password dimenticata?',
      submit: 'Accedi',
      submitting: 'Accesso...',
      error: 'Email o password non corretti',
      notMember: 'Non sei ancora socio?',
      register: 'Registrati',
      devMode: '🛠️ Modalità sviluppo',
      show: 'Mostra',
      hide: 'Nascondi',
      devHint:
        'Accesso rapido per lo sviluppo locale (non disponibile in produzione)',
      devLoading: 'Caricamento utenti...',
      devNone: 'Nessun utente trovato',
    },
    forgotPassword: {
      title: 'Password dimenticata',
      intro:
        'Inserisci la tua email. Se esiste un account, riceverai un link per reimpostare la password.',
      emailLabel: 'Email',
      submit: 'Invia il link',
      submitting: 'Invio...',
      sending: 'Invio in corso...',
      backLogin: 'Torna all’accesso',
      errorGeneric: 'Si è verificato un errore. Riprova.',
      successBody:
        'Ti abbiamo inviato un’email con le istruzioni per reimpostare la password. Controlla la posta in arrivo (e lo spam).',
      notFound: 'Nessun account associato a questa email.',
      notFoundBold: 'Nessun account associato a questo indirizzo email.',
      notFoundCreate: 'Vuoi creare un account?',
      registerCta: 'Registrati',
    },
    resetPassword: {
      pageTitle: 'Reimpostazione password',
      checking: 'Verifica del link...',
      checkingShort: 'Verifica del link...',
      invalidTitle: 'Link non valido o scaduto',
      invalidBody:
        'Questo link di reimpostazione non è valido o è scaduto. Richiedine uno nuovo.',
      requestNewLink: 'Richiedi un nuovo link',
      title: 'Nuova password',
      formIntro: 'Scegli una nuova password per il tuo account.',
      password: 'Nuova password *',
      confirm: 'Conferma password *',
      submit: 'Reimposta la password',
      submitting: 'Salvataggio...',
      successTitle: 'Password reimpostata',
      successBody:
        'La password è stata reimpostata. Ora puoi accedere.',
      successTitleAlt: 'Password aggiornata',
      successBodyAlt: 'Ora puoi accedere con la nuova password.',
      goLogin: 'Accedi',
      mismatch: 'Le password non coincidono.',
      tooShort: 'La password deve contenere almeno 6 caratteri.',
      errorGeneric: 'Si è verificato un errore. Riprova.',
      backLogin: 'Torna all’accesso',
    },
    magicLink: {
      pageTitle: 'Verifica link di accesso',
      verifying: 'Verifica in corso...',
      success: 'Accesso effettuato! Reindirizzamento...',
      backLoginPage: 'Torna alla pagina di accesso',
    },
    membership: {
      loading: 'Caricamento...',
      inactiveForSeason:
        'Il tuo stato di socio non è attivo per la stagione 2026-2027. Non puoi ordinare biglietti né richiedere una Juventus Card. Contatta il club se ritieni che si tratti di un errore.',
    },
    juventusCard: {
      title: 'Juventus Card',
      intro:
        '<p>La Juventus Card è necessaria per:</p><ul><li>Acquistare biglietti e accedere allo stadio per le partite soggette a limitazioni di vendita</li><li>Acquisto biglietti settore ospiti in Italia</li><li>Acquistare l\'abbonamento stagionale</li><li>Ricevere un cambio nome da un abbonato</li></ul><p>La Juventus Card è comunque consigliata — meglio farla tramite il club.</p>',
      loginHint:
        'Hai già inviato una richiesta? Accedi per vedere lo stato e accedere al modulo di smarrimento.',
      loading: 'Caricamento...',
      statusTitle: 'Stato della tua richiesta Juventus Card',
      statusLabel: 'Stato:',
      statusPending: 'In elaborazione',
      statusProcessed: 'Evasa',
      requestDate: 'Richiesta del',
      lostCta: 'Dichiarare lo smarrimento della Juventus Card',
      ctaText: 'Per richiedere la Juventus Card, compila il modulo dedicato.',
      ctaRequest: 'Richiedi la Juventus Card',
      inactiveHint: 'Accedi con un account socio attivo per la stagione 2026-2027.',
    },
    terms: {
      title: 'Regolamenti e condizioni',
      intro:
        'Scarica i documenti ufficiali Juventus (Allianz Stadium, Juventus Card, membership, abbonamenti e biglietti) in formato PDF.',
      download: 'Scarica il PDF',
    },
    paiement: {
      title: 'Pagamento e conti bancari',
      chfTitle: 'Conto in franchi svizzeri',
      chfPurpose: 'Conto in CHF per il pagamento della quota associativa',
      eurTitle: 'Conto in euro',
      eurPurpose:
        'Conto in euro per il pagamento della quota, biglietti, Juventus Card e abbonamento',
      beneficiary: 'Beneficiario:',
      address: 'Indirizzo:',
      iban: 'IBAN:',
      bic: 'BIC:',
      postal: 'Conto postale:',
      pricingTitle: 'Quote Stagione 2026-2027',
      paymentMode: 'Modalità di pagamento',
      tierAdult: 'JOFC Adult',
      tierU14: 'Under 14',
      tierU5: 'Under 5',
      tierU5TableFree: 'Gratuita',
      priceChf: 'Prezzo (CHF)',
      priceEur: 'Prezzo (€)',
      ebanking: 'E-banking',
      twint: 'Twint al 0786289688',
      revolut: '*Carta Revolut',
      credit: '*Carta di credito',
      smsNote: 'Invia SMS o WhatsApp al +41786289688',
      cotisationAdultTitle: 'JOFC Adult — 40 CHF / 40 €',
      cotisationAdultBody:
        'Incluso: Membership Black &amp; White digitale gratuita + un portachiavi',
      cotisationU14Title: 'Under 14 — 30 CHF / 30 €',
      cotisationU14Body:
        '(nati dopo il 01.07.2013)<br /><br />Incluso: Membership Junior + un beanie',
      cotisationU5Title: 'Under 5 — Gratuita',
      cotisationU5Body: '(nati dopo il 01.07.2022)',
      juveCardTitle: 'Prezzi Juventus Card (ex tessera del tifoso) stagione 2026-2027',
    },
    account: {
      pageTitle: 'Il mio account',
      loading: 'Caricamento...',
      loadError: 'Errore durante il caricamento dei dati',
      alertLoadError: 'Errore durante il caricamento dei dati',
      alertSaveOk: 'Profilo aggiornato con successo',
      alertSaveError: 'Errore durante l’aggiornamento',
      alertDeleteOk:
        'La richiesta di eliminazione dell’account è stata registrata. Un amministratore ti contatterà a breve.',
      alertDeleteError: 'Errore durante l’invio della richiesta',
      sectionAccount: 'Informazioni account',
      sectionReadonly: 'Dati personali (non modificabili)',
      civMonsieur: 'Signore',
      civMadame: 'Signora',
      civility: 'Titolo',
      firstName: 'Nome',
      lastName: 'Cognome',
      dateOfBirth: 'Data di nascita',
      sexe: 'Sesso',
      sexeHomme: 'Uomo',
      sexeFemme: 'Donna',
      membershipType: 'Tipo di tessera / adesione',
      ecardCode: 'e-card',
      pnrCode: 'Codice PNR',
      sectionEditable: 'Dati modificabili',
      emailPrimary: 'Email principale *',
      emailSecondary: 'Email secondaria',
      emailOptionalPh: 'Email facoltativa',
      phone: 'Telefono *',
      phonePh: '+41791234567',
      addressTitle: 'Indirizzo',
      street: 'Via *',
      streetNumber: 'N. civico *',
      city: 'Città *',
      canton: 'Cantone',
      cantonPh: 'VD, VS, GE, ecc.',
      postalCode: 'CAP *',
      country: 'Paese *',
      save: 'Salva modifiche',
      saving: 'Salvataggio...',
      sectionConsents: 'Consensi e comunicazioni',
      consentsIntro: 'Puoi modificare le tue preferenze di consenso in qualsiasi momento.',
      consentNewsletter: 'Desidero ricevere la newsletter e le informazioni sugli eventi del club',
      sectionPrefs: 'Preferenze account',
      prefLang: 'Lingua preferita',
      prefLangHelp: 'Usata per le e-mail del club e la visualizzazione del sito.',
      saveLanguage: 'Salva lingua',
      savingLanguage: 'Salvataggio...',
      alertLanguageOk: 'Lingua preferita aggiornata',
      alertLanguageError: 'Errore durante l’aggiornamento della lingua',
      langFr: 'Francese',
      langIt: 'Italiano',
      memberSince: 'Socio dal:',
      statusLabel: 'Stato:',
      statusActive: 'Socio attivo',
      sectionOrders: 'Cronologia ordini',
      loadingOrders: 'Caricamento ordini...',
      noOrders: 'Nessun ordine di biglietti al momento.',
      orderMatchFallback: 'Partita',
      orderStadium: 'Stadio:',
      orderDate: 'Data:',
      orderQty: 'Quantità:',
      orderTickets: '{n} biglietto/i',
      orderPlaced: 'Data ordine:',
      orderNotes: 'Note:',
      orderStatusPending: 'In attesa',
      orderStatusConfirmed: 'Confermato',
      orderStatusCancelled: 'Annullato',
      na: 'N/D',
      membershipUndefined: 'Non definito',
      membershipPlusU14: 'PLUS U14',
      membershipPlus: 'PLUS',
      membershipStar: 'Star',
      membershipBase: 'Base',
      membershipStandard: 'Standard',
      membershipAbonne: 'Abbonato',
      membershipNonAbonne: 'Non abbonato',
      membershipUnder5: 'Under 5',
      membershipJofcAdult: 'JOFC Adult',
      membershipJofcUnder14: 'JOFC Under 14',
      membershipJofcUnder5: 'JOFC Under 5',
      membershipJofcFull: 'JOFC Abbonato Full',
      membershipNewsletter: 'Newsletter',
      sectionDanger: 'Eliminazione account',
      dangerP1:
        'Se desideri eliminare il tuo account e tutti i dati associati, puoi inviare una richiesta qui sotto.',
      dangerWarn: 'Attenzione:',
      dangerP2:
        'Questa azione è irreversibile. Un amministratore ti contatterà per confermare l’eliminazione.',
      dangerCta: 'Richiedi l’eliminazione del mio account',
      modalTitle: 'Conferma richiesta di eliminazione',
      modalP1: 'Vuoi davvero richiedere l’eliminazione del tuo account?',
      modalP2:
        'Verrà inviata una richiesta all’amministratore. Sarai contattato per confermare l’eliminazione definitiva.',
      modalConfirm: 'Conferma richiesta',
      modalCancel: 'Annulla',
    },
    newsCard: {
      readArticle: 'Leggi l’articolo',
    },
    registerForm: registerFormIt,
  },
};
